import { useMemo } from 'react';
import { Box } from '@rsos/components/capstone/base';
import { ChatComponentType, useChatComponents } from '../useChatComponents';
import AgencyShareChatBox from './AgencyShareChat/ASCChatBox';
import CollaboratorChatbox from './CollaboratorChatBox/CollaboratorChatbox';
import ConversationsChatBox from './ConversationsChatBox/ConversationsChatbox';
import RcsChatBox from './RcsChatBox/RcsChatBox';
import TF911ChatBox from './TF911ChatBox/TF911ChatBox';

interface CallChatsProps {
  isAgencyShareChatChatBoxVisible: boolean;
  isTextFrom911ChatBoxVisible: boolean;
  isRcsChatBoxVisible: boolean;
  onCollapseChat: () => void;
}

const CallChats = ({
  isAgencyShareChatChatBoxVisible,
  isTextFrom911ChatBoxVisible,
  isRcsChatBoxVisible,
  onCollapseChat,
}: CallChatsProps) => {
  const {
    chatComponentType,
    shouldRenderAgencyShareChat,
    bothChatsEnabled,
    shouldRenderCollaboratorChat,
  } = useChatComponents();

  const chatComponent = useMemo(() => {
    if (chatComponentType === ChatComponentType.Conversations) {
      // All future sources should lead to here
      return <ConversationsChatBox />;
    }

    if (chatComponentType === ChatComponentType.RCS) {
      // Free TF911 module (Google RCS or Standard SMS)
      return (
        <RcsChatBox
          isRcsChatBoxVisible={isRcsChatBoxVisible}
          onCollapseChat={onCollapseChat}
        />
      );
    }

    if (chatComponentType === ChatComponentType.TF911) {
      // Base TF911
      return (
        <TF911ChatBox
          isTextFrom911ChatBoxVisible={isTextFrom911ChatBoxVisible}
          onCollapseChat={onCollapseChat}
        />
      );
    }

    return null;
  }, [
    chatComponentType,
    isTextFrom911ChatBoxVisible,
    isRcsChatBoxVisible,
    onCollapseChat,
  ]);

  return (
    <Box data-name="call-chats" height="100%" overflowY="auto" gridRowGap="8px">
      {chatComponent}
      {shouldRenderCollaboratorChat && <CollaboratorChatbox />}
      {shouldRenderAgencyShareChat && (
        <AgencyShareChatBox
          bothChatsEnabled={bothChatsEnabled}
          isAgencyShareChatChatBoxVisible={isAgencyShareChatChatBoxVisible}
          onCollapseChat={onCollapseChat}
        />
      )}
    </Box>
  );
};

export default CallChats;
